/* eslint-disable react/jsx-key */
import { useEffect, Fragment } from 'react'

import { useReactiveVar } from '@apollo/client'
import { createPortal } from 'react-dom'

import { IS_BROWSER, MODAL_ROOT_ID } from '@web/libs/constants'

import { closeLatestShowingModal, closeModal, modalListVar } from './globalModal.helper'
import ModalBackground from './ModalBackground'

const GlobalModalPortal = () => {
  const modalList = useReactiveVar(modalListVar)

  const showingModalList = modalList.filter(modal => modal.isShow)

  const showingTopModal = showingModalList.length ? showingModalList[showingModalList.length - 1] : undefined

  useEffect(() => {
    if (showingTopModal) {
      document.body.classList.add('place_modal_open')
      return
    }

    document.body.classList.remove('place_modal_open')
  }, [showingTopModal])

  if (!IS_BROWSER) return null

  return createPortal(
    <>
      {modalList.map(({ id, isShow, ModalComponent, options }) => {
        return (
          <Fragment key={id}>
            {id === showingTopModal?.id && (
              <ModalBackground
                show
                onClick={() => {
                  options?.callback?.cancel?.()
                  closeLatestShowingModal()
                }}
              />
            )}
            <ModalComponent
              key={id}
              showModal={isShow}
              cancelModal={e => {
                options?.callback?.cancel?.(e)
                closeModal(id)
              }}
              confirmModal={e => {
                options?.callback?.confirm?.(e)
                options?.autoCloseAfterConfirm === false ? null : closeModal(id)
              }}
              {...options}
            />
          </Fragment>
        )
      })}
    </>,
    document.getElementById(MODAL_ROOT_ID) as Element,
  )
}

export default GlobalModalPortal
